import type { RouteRecordRaw } from 'vue-router'
import api from '../../services/api' // axios instance
import { BookingConfigPage } from '@myorg/booking-lib'
import {ROUTES, API_ENDPOINTS} from '@myorg/type-lib'
import { BookTableConfig,BookingOrderApi,BookingConfigApi, BookingRequest } from '@myorg/type-lib';
import type { TimeConfigApi, BookTimeConfig } from '@myorg/type-lib';
import { HolidayMap,HolidayAdminApi } from '@myorg/type-lib'


// 實作符合 Lib 介面的 API 物件
export const bookingApiImpl:BookingConfigApi = {
  // 對應後端 GetMerchantConfigs
  getConfigs: async () => {
    const res = await api().get(API_ENDPOINTS.BOOKING.CONFIG)
    return res.data
  },
  
  // 對應後端 UpsertConfig
  upsertConfig: async (config: any) => {
    const res = await api().post(API_ENDPOINTS.BOOKING.CONFIG, config)
    return res.data
  }
}

// App Repo: services/timeConfigApiImpl.ts

export const timeConfigApiImpl: TimeConfigApi = {
  async fetchConfigs() {
    const res = await api().get(API_ENDPOINTS.BOOKING.TIME_CONFIG);
    return res.data;
  },
  async saveConfigs(configs: BookTimeConfig[]) {
    await api().post(API_ENDPOINTS.BOOKING.TIME_CONFIG, configs);
  }
};


export const holidayApiImpl:HolidayAdminApi = {
  // 後端回傳格式預期為 {"0":[1], "1":[1225], "2":[15]}
  getHolidays: async () => {
    const res = await api().get(API_ENDPOINTS.BOOKING.HOLIDAYS)
    return res.data
  },

  // 直接傳送分類後的 Map，由後端 Service 進行 RuleCode 合併字串
  saveHolidays: async (data: any) => {
    const res = await api().post(API_ENDPOINTS.BOOKING.HOLIDAYS, data)
    return res.data
  }
}


export const bookingRoute: RouteRecordRaw = {
  path: ROUTES.BOOKING.CONFIG.PATH,
  name: ROUTES.BOOKING.CONFIG.NAME,
  component: BookingConfigPage as any,
  props: {
    bookingApi: bookingApiImpl,
    bookingTimeApi: timeConfigApiImpl,
    holidayApi: holidayApiImpl,
  }
}
